import { putApi } from "../apis";

/**
 * Updates the user profile data for a specific user ID using the provided profile data.
 */
export const updateUserProfileData = (profileData) => {
    const { data, userId } = profileData;
    return putApi(`user?userId=${userId}`, data);
}